import List from './list' 
import Show from './show' 
import DriverIcon from '@material-ui/icons/Person';

export default{
    list: List,
    show: Show,
    icon: DriverIcon,
}